import { jsxs, jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import { getSmallCase } from '@nicollet/common';
import { OptionItemCheckbox } from './OptionItemCheckbox.js';
import { OptionItem } from './OptionItem/OptionItem.js';
import CloseLink from './CloseLink.js';
import { OptionsList } from './OptionsList.js';
import { focusTrap } from '../../focusTrap/index.js';

const Elements = {
  default: OptionItem,
  checkbox: OptionItemCheckbox
};

class Options extends Component {
  constructor(props) {
    super(props);
    this.container = null;
    this.focusItemRef = null;
    this.setFocusItemRef = this.setFocusItemRef.bind(this);
    this.setContainerRef = this.setContainerRef.bind(this);
    this.handleCloseLinkFocus = this.handleCloseLinkFocus.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      var _a, _b, _c;

      return (_c = (_b = (_a = this.focusItemRef) === null || _a === void 0 ? void 0 : _a.querySelector('input')) !== null && _b !== void 0 ? _b : this.focusItemRef) === null || _c === void 0 ? void 0 : _c.focus();
    }, 0);
  }

  setContainerRef(el) {
    const {
      childRef
    } = this.props;

    if (el) {
      this.container = el; // pass the ref back up to the parent if chilfRef is passed through props

      if (childRef) childRef(el);
    }
  }

  setFocusItemRef(el) {
    this.focusItemRef = el;
  }

  getFocusHandler(option, index, multiSelect) {
    if (multiSelect || !option.selected) {
      return index === 0 ? this.setFocusItemRef : null;
    }

    return this.setFocusItemRef;
  }

  handleCloseLinkFocus() {
    /**
     * Force the container (UL) to its maximum "scrollTop" value, allowing the
     * "close list" link to be visible.
     */
    if (this.container) {
      this.container.scrollTop += 100;
    }
  }

  render() {
    const {
      options,
      onChange,
      onClose,
      multiSelect,
      type = 'default',
      target,
      modalHeight,
      dataTestPrefix,
      disabledOptionText,
      modalWidth
    } = this.props;
    const Element = Elements[type];
    const optionStyle = modalHeight ? {
      modalHeight
    } : undefined;
    return jsxs(OptionsList, Object.assign({
      optionsWidth: modalWidth,
      ref: this.setContainerRef,
      style: optionStyle,
      type: type
    }, {
      children: [disabledOptionText && jsx("li", {
        children: jsx(OptionItem, {
          data: {
            label: disabledOptionText
          },
          disabled: true
        }, void 0)
      }, void 0), options.map((option, index) => jsx("li", {
        children: jsx(Element, {
          childRef: this.getFocusHandler(option, index, multiSelect),
          data: option,
          "data-test": `${dataTestPrefix}${getSmallCase(option.value)}`,
          multiSelect: multiSelect,
          name: option.value,
          onChange: onChange
        }, void 0)
      }, option.value)), jsx("li", {
        children: jsx(CloseLink, {
          href: target,
          onClick: onClose,
          onFocus: this.handleCloseLinkFocus
        }, void 0)
      }, void 0)]
    }), void 0);
  }

}

Options.displayName = 'Options';
var Options$1 = focusTrap(Options, {
  allowArrowKeyNavigation: true
});

export { Options$1 as default };
